import React from 'react';
import AssetCard from './AssetCard';
import './AssetGrid.css';

function AssetGrid({ assets, loading }) {
  // ✅ Ensure assets is always an array (prevents blank screen)
  const safeAssets = Array.isArray(assets) ? assets : [];

  if (loading) {
    return (
      <div className="asset-grid-container">
        <div className="loading">Loading assets...</div>
      </div>
    );
  }

  if (safeAssets.length === 0) {
    return (
      <div className="asset-grid-container">
        <div className="empty-state">
          <p>No assets found. Try a different search or category.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="asset-grid-container">
      <div className="asset-grid">
        {safeAssets.map((asset, index) => (
          <AssetCard key={asset?.id ?? index} asset={asset} />
        ))}
      </div>
    </div>
  );
}

export default AssetGrid;
